import {
  CcfBox,
  CcfHyperlinkIcon,
  CcfNewWindowIcon,
  CcfTooltip,
  CcfTypography,
  useTranslator,
} from '@nice-ccf/ui-controls';
import styles from '../ccf-consumer-card-external-data-tab/ccf-consumer-card-external-data-tab.module.scss';
import { Card, CardContent, IconButton } from '@mui/material';
import Link from '@mui/material/Link';
import CheckIcon from '@mui/icons-material/Check';
import { useState } from 'react';
import { activeContactSelector } from '../../../ccf-inbox/ccf-inbox.slice';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import advancedFormat from 'dayjs/plugin/advancedFormat';

/* eslint-disable-next-line */
export interface CcfExternalDataTabRecordsProps {
  overviewMinValue: any;
  externalTabData: any;
}

/**@example */
export function CcfExternalDataTabRecords(
  props: CcfExternalDataTabRecordsProps
) {
  const { overviewMinValue, externalTabData } = props;
  const activeContact = useSelector(activeContactSelector);
  dayjs.extend(utc);
  dayjs.extend(advancedFormat);

  const [relatedRecords, setRelatedRecords] = useState(
    activeContact?.recentInteraction
  );
  const [toggleCurrentRecord, setToggleCurrentRecord] = useState(true);
  const [translate] = useTranslator();
  /**
   * function to toggke icon
   *
   * @param newExpanded - boolean
   * @example -  toggleIcon()
   */
  const toggleIcon = (index: any) => {
    const isIconTick = [...relatedRecords];
    isIconTick[index] = {
      ...isIconTick[index],
      isCopy: !isIconTick[index].isCopy,
    };
    setRelatedRecords(isIconTick);
  };

  return (
    <div
      style={
        overviewMinValue
          ? { width: '100%', padding: '10px' }
          : {
              width: activeContact?.customer.externalDataLoyaltyInfoHide
                ? '50%'
                : '100%',
              padding: '10px',
              paddingTop: '0px',
            }
      }
      id={`agent_appSpace_externalTab_serviceNow_parentDiv`}
    >
      <div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <CcfTypography className={styles.headerText}>
            ServiceNow CRM
          </CcfTypography>
          <IconButton>
            <CcfNewWindowIcon />
          </IconButton>
        </div>
        <div className={styles.recordParent}>
          <CcfTypography
            translationKey={activeContact?.recentInteraction[0].recordType}
            className={styles.recordType}
          ></CcfTypography>

          <Card
            variant="outlined"
            style={{ marginBottom: '5px', cursor: 'pointer' }}
          >
            <CardContent className={styles.recordContent}>
              <CcfBox className={styles.recordDetailsBlock}>
                <CcfBox className={styles.recordMinParentContainer}>
                  <CcfBox className={styles.recordDetails}>
                    <CcfTypography className={styles.caseTitle}>
                      {
                        activeContact?.recentInteraction[0].label
                          .split(',')
                          .map((part: any) => part.trim())[0]
                      }{' '}
                      {`${
                        activeContact?.recentInteraction[0].label
                          .split(',')
                          .map((part: any) => part.trim())[1]
                      }`}
                    </CcfTypography>
                    <CcfBox style={{ display: 'flex', gap: '5px' }}>
                      <CcfBox
                        className={
                          toggleCurrentRecord
                            ? styles.linkIcon
                            : styles.greenStatus
                        }
                      >
                        <IconButton
                          style={{ padding: '0px' }}
                          onClick={() => {
                            setToggleCurrentRecord(!toggleCurrentRecord);
                          }}
                          id={`agent_appSpace_externalTab_hyperLink`}
                        >
                          {toggleCurrentRecord ? (
                            <CcfHyperlinkIcon
                              fillColor="#ffffff"
                              className={styles.articleIcon}
                            />
                          ) : (
                            <CheckIcon className={styles.tickIcon} />
                          )}
                        </IconButton>{' '}
                      </CcfBox>
                      <div
                        style={{ height: '25px' }}
                        id={`agent_appSpace_externalDataTab_nowContact`}
                      >
                        <CcfTooltip
                          title="ServiceNow 2 Contact"
                          arrow
                          placement="top"
                          styles={{
                            ccfTooltipArrow: {
                              color: 'white',
                            },
                            ccfTooltip: {
                              borderRadius: '6px',
                              backgroundColor: 'white',
                              boxShadow: '0px 5px 15px 0px rgb(0 0 0 / 30%)',
                              color: 'black',
                            },
                          }}
                        >
                          <div>
                            <Link
                              target="_blank"
                              href={`${activeContact?.recentInteraction[0].crmUrl}`}
                              underline="none"
                              rel="noreferrer"
                            >
                              <img
                                src={`${activeContact?.recentInteraction[0].crmIcon}`}
                                style={{ width: '70px', height: '25px' }}
                                alt={'nowCase'}
                              />
                            </Link>
                          </div>
                        </CcfTooltip>
                      </div>
                    </CcfBox>
                    <CcfBox
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                      }}
                    >
                      <CcfTypography
                        style={{
                          color: '#767676',
                          fontWeight: '600',
                          fontSize: '11px',
                        }}
                      >
                        {`${translate('priority')}  : `}
                      </CcfTypography>
                      <CcfTypography
                        className={styles.statusText}
                        translationKey={
                          activeContact?.recentInteraction[0].status
                        }
                      ></CcfTypography>
                    </CcfBox>
                    <CcfTypography
                      style={{
                        color: '#767676',
                        fontWeight: '400',
                        fontSize: '12px',
                      }}
                    >
                      {`${dayjs(activeContact?.recentInteraction[0].date)
                        .utc()
                        .format('MM/DD/YYYY hh:mm A')} | ${
                        activeContact?.recentInteraction[0].details
                      }`}
                    </CcfTypography>
                  </CcfBox>{' '}
                </CcfBox>
              </CcfBox>
            </CardContent>
          </Card>
          <CcfTypography
            translationKey={activeContact?.recentInteraction[1].recordType}
            className={styles.recordType}
          ></CcfTypography>
          {relatedRecords.slice(1).map((record: any, i: any) => (
            <Card
              variant="outlined"
              style={{ marginBottom: '5px', cursor: 'pointer' }}
            >
              <CardContent className={styles.recordContent}>
                <CcfBox className={styles.recordDetailsBlock}>
                  <CcfBox className={styles.recordMinParentContainer}>
                    <CcfBox className={styles.recordDetails}>
                      <CcfTypography className={styles.caseTitle}>
                        {
                          record.label
                            .split(',')
                            .map((part: any) => part.trim())[0]
                        }{' '}
                        {`${
                          record.label
                            .split(',')
                            .map((part: any) => part.trim())[1]
                        }`}
                      </CcfTypography>
                      <CcfBox style={{ display: 'flex', gap: '5px' }}>
                        <CcfBox
                          className={
                            record.isCopy ? styles.linkIcon : styles.greenStatus
                          }
                        >
                          <IconButton
                            style={{ padding: '0px' }}
                            onClick={() => {
                              toggleIcon(i + 1);
                            }}
                            id={`agent_appSpace_externalTab_hyperLink`}
                          >
                            {record.isCopy ? (
                              <CcfHyperlinkIcon
                                fillColor="#ffffff"
                                className={styles.articleIcon}
                              />
                            ) : (
                              <CheckIcon className={styles.tickIcon} />
                            )}
                          </IconButton>{' '}
                        </CcfBox>
                        <div
                          style={{ height: '25px' }}
                          id={`agent_appSpace_externalDataTab_nowContact`}
                        >
                          <CcfTooltip
                            title="ServiceNow 2 Contact"
                            arrow
                            placement="top"
                            styles={{
                              ccfTooltipArrow: {
                                color: 'white',
                              },
                              ccfTooltip: {
                                borderRadius: '6px',
                                backgroundColor: 'white',
                                boxShadow: '0px 5px 15px 0px rgb(0 0 0 / 30%)',
                                color: 'black',
                              },
                            }}
                          >
                            <div>
                              <Link
                                target="_blank"
                                href={`${record.crmUrl}`}
                                underline="none"
                                rel="noreferrer"
                              >
                                <img
                                  src={`${record.crmIcon}`}
                                  style={{ width: '70px', height: '25px' }}
                                  alt={'nowCase'}
                                />
                              </Link>
                            </div>
                          </CcfTooltip>
                        </div>
                      </CcfBox>
                      <CcfBox
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                        }}
                      >
                        <CcfTypography
                          className={styles.closedText}
                          translationKey={record.status}
                        ></CcfTypography>
                      </CcfBox>
                      <span
                        style={{
                          color: '#767676',
                          fontWeight: '400',
                          fontSize: '12px',
                        }}
                      >
                        {dayjs(record.date).utc().format('MM/DD/YYYY hh:mm A')}{' '}
                        | {record.details}
                      </span>
                    </CcfBox>{' '}
                  </CcfBox>
                </CcfBox>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CcfExternalDataTabRecords;
